import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_LABOR_CLASS = 'ADD_LOCAL_LABOR_CLASS';
export const REMOVE_LOCAL_LABOR_CLASS = 'REMOVE_LOCAL_LABOR_CLASS';
export const API_LOAD_LABOR_CLASSES = 'API_LOAD_LABOR_CLASSES';
export const API_REMOVE_LABOR_CLASS = 'API_REMOVE_LABOR_CLASS';
export const API_CREATE_LABOR_CLASS = 'API_CREATE_LABOR_CLASS';
export const API_UPDATE_LABOR_CLASS = 'API_UPDATE_LABOR_CLASS';

const API_LOAD_LABOR_CLASSES_FAILED = 'API_LOAD_LABOR_CLASSES_FAILED';
const API_LOAD_LABOR_CLASSES_LOADING = 'API_LOAD_LABOR_CLASSES_LOADING';
const API_LOAD_LABOR_CLASSES_LOADED = 'API_LOAD_LABOR_CLASSES_LOADED';
const API_REMOVE_LABOR_CLASS_FAILED = 'API_REMOVE_LABOR_CLASS_FAILED';
const API_REMOVE_LABOR_CLASS_LOADING = 'API_REMOVE_LABOR_CLASS_LOADING';
const API_REMOVE_LABOR_CLASS_SUCCESS = 'API_REMOVE_LABOR_CLASS_SUCCESS';
const API_CREATE_LABOR_CLASS_FAILED = 'API_CREATE_LABOR_CLASS_FAILED';
const API_CREATE_LABOR_CLASS_LOADING = 'API_CREATE_LABOR_CLASS_LOADING';
const API_CREATE_LABOR_CLASS_SUCCESS = 'API_CREATE_LABOR_CLASS_SUCCESS';
const API_UPDATE_LABOR_CLASS_FAILED = 'API_UPDATE_LABOR_CLASS_FAILED';
const API_UPDATE_LABOR_CLASS_LOADING = 'API_UPDATE_LABOR_CLASS_LOADING';
const API_UPDATE_LABOR_CLASS_SUCCESS = 'API_UPDATE_LABOR_CLASS_SUCCESS';

const defaultState = { laborClasses: [], loading: false };
const emptyLaborClass = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = laborClass => ({ ...emptyLaborClass(), ...laborClass });

// eslint-disable-next-line object-curly-newline
export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_LABOR_CLASSES_LOADED:
      return update(state, {
        loading: { $set: false },
        laborClasses: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_LABOR_CLASSES_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_LABOR_CLASSES_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_LABOR_CLASS:
      return update(state, { laborClasses: { $push: [emptyLaborClass()] } });
    case API_REMOVE_LABOR_CLASS_SUCCESS:
    case REMOVE_LOCAL_LABOR_CLASS:
      return update(state, { laborClasses: { $splice: [[indexById(id, state.laborClasses), 1]] } });
    case API_REMOVE_LABOR_CLASS_FAILED:
      return update(state, { laborClasses: { [indexById(id, state.laborClasses)]: { removing: { $set: false } } } });
    case API_REMOVE_LABOR_CLASS_LOADING:
      return update(state, { laborClasses: { [indexById(id, state.laborClasses)]: { removing: { $set: true } } } });
    case API_CREATE_LABOR_CLASS_FAILED:
      return update(state, { laborClasses: { [indexById(resource.id, state.laborClasses)]: { saving: { $set: false } } } });
    case API_CREATE_LABOR_CLASS_LOADING:
      return update(state, { laborClasses: { [indexById(resource.id, state.laborClasses)]: { saving: { $set: true } } } });
    case API_CREATE_LABOR_CLASS_SUCCESS:
      return update(state, { laborClasses: { $splice: [[indexById(replaceId, state.laborClasses), 1, response]] } });
    default:
      return state;
  }
};

export const laborClasses = state => state.laborClasses.laborClasses.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const loading = state => state.laborClasses.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/laborClasses/laborClasses.reducer.js